import { FlowType } from '@ply-io/ply-front-shared-utilities';

import WorkflowService from './WorkflowService';
import {
	DEFAULT_OTHER_TOOL_PLACEMENT_TITLE,
	TOOL_PREFERENCES_FLAGS_TO_CONTENT,
	URL_PLACEMENT_ID,
	COMMAND_BAR_PLACEMENT_ID,
	TOOL_TITLE_OF_TOOL_PLACEMENT,
	WORKFLOW_TITLE_FOR_TOOL_PLACEMENT,
	SLACK_PLACEMENT_ID,
} from './workflow-tool-service.const';

// Private
const getMatchingToolPlacementContent = (workflow) =>
	Object.entries(TOOL_PREFERENCES_FLAGS_TO_CONTENT).find(([flagKey]) => getToolPreferences(workflow)[flagKey])?.[1];

const getMainPlacementOfTool = (workflow) => workflow.flow_type === FlowType.Tool && getToolPreferences(workflow).main_placement;

// Public
const getToolPreferences = (workflow) => workflow.tool_preferences;
export const isURLTool = (workflow) => getMainPlacementOfTool(workflow) === URL_PLACEMENT_ID;
export const isCommandBarTool = (workflow) =>
	!!getToolPreferences(workflow) && getMainPlacementOfTool(workflow) === COMMAND_BAR_PLACEMENT_ID;

export const isSlackTool = (workflow) => !!getToolPreferences(workflow) && getMainPlacementOfTool(workflow) === SLACK_PLACEMENT_ID;
const isPortalTool = (workflow) => isURLTool(workflow) && WorkflowService.isPublicAccess(workflow);
const isInternalToolFromUrl = (workflow) => isURLTool(workflow) && !WorkflowService.isPublicAccess(workflow);

const getMatchingToolTitle = (workflow) => {
	if (isURLTool(workflow)) {
		return WorkflowService.getRunLink(workflow);
	} else if (isCommandBarTool(workflow)) {
		return getToolPreferences(workflow).command_bar_title;
	} else if (isSlackTool(workflow)) {
		return `/ply ${workflow.workflow_title}`;
	}
	return 'Tool';
};
const getMatchingToolPlacementIcon = (workflow) => getMatchingToolPlacementContent(workflow).icon;
const getMatchingToolPlacementTitle = (workflow) => getMatchingToolPlacementContent(workflow).title;

export const getToolPlacementTitle = (workflow) =>
	TOOL_TITLE_OF_TOOL_PLACEMENT[getMainPlacementOfTool(workflow)] || DEFAULT_OTHER_TOOL_PLACEMENT_TITLE;

const getToolWorkflowFullTitle = (workflow) => {
	const prefix = getFeatureTitle(workflow);
	return `${prefix} ${WORKFLOW_TITLE_FOR_TOOL_PLACEMENT[getMainPlacementOfTool(workflow)] || `at ${DEFAULT_OTHER_TOOL_PLACEMENT_TITLE}`}`;
};

const getToolMappedFields = (workflow) => {
	const toolMappedFields = {};
	const workflowIsTool = WorkflowService.isOfTypeTool(workflow);
	if (workflowIsTool) {
		const isToolOfCommandBar = isCommandBarTool(workflow);
		if (isToolOfCommandBar) {
			const toolPreferences = getToolPreferences(workflow);
			toolMappedFields.url = toolPreferences?.command_bar_created_in_url || 'http://ply.io';

			// Selected text feature
			toolMappedFields.selectedText = 'sample';
		}
	}
	return toolMappedFields;
};

const getFeatureTitle = (workflow) => (WorkflowService.isPublicAccess(workflow) ? 'Portal' : 'Tool');

const WorkflowToolService = {
	getToolPreferences,
	isURLTool,
	isCommandBarTool,
	getMatchingToolTitle,
	getMatchingToolPlacementIcon,
	getMatchingToolPlacementTitle,
	getToolPlacementTitle,
	getToolWorkflowFullTitle,
	getToolMappedFields,
	getFeatureTitle,
	isSlackTool,
	isPortalTool,
	isInternalToolFromUrl,
};

export default WorkflowToolService;
